module.exports = __webpack_public_path__ + "img/6.ec6203a0.png";